export const WAEC_CHEMISTRY = [
  {
    q: "What is the atomic number of Carbon?",
    o: ["4", "6", "8", "12"],
    a: 1,
    e: "Carbon has 6 protons, so its atomic number is 6.",
    h: "Atomic number = number of protons.",
    yr: "2023",
  },
  {
    q: "Which gas is produced when zinc reacts with dilute hydrochloric acid?",
    o: ["Oxygen", "Carbon dioxide", "Hydrogen", "Chlorine"],
    a: 2,
    e: "Zn + 2HCl → ZnCl₂ + H₂↑. Hydrogen gas is produced.",
    h: "Metal + acid → salt + hydrogen.",
    yr: "2022",
  },
  {
    q: "pH of a neutral solution at 25°C is:",
    o: ["0", "7", "10", "14"],
    a: 1,
    e: "A neutral solution has equal concentrations of H⁺ and OH⁻. pH 7 is neutral.",
    h: "Below 7 = acidic, above 7 = basic.",
    yr: "2023",
  },
  {
    q: "What type of bond is formed between Na and Cl?",
    o: ["Covalent", "Ionic", "Metallic", "Hydrogen"],
    a: 1,
    e: "Na transfers one electron to Cl, forming Na⁺ and Cl⁻ ions. This electrostatic attraction is an ionic bond.",
    h: "Metal + non-metal = ionic bond.",
    yr: "2021",
  },
  {
    q: "Which law states that gases at constant temperature have pressure inversely proportional to volume?",
    o: ["Charles' Law", "Avogadro's Law", "Boyle's Law", "Dalton's Law"],
    a: 2,
    e: "Boyle's Law: P₁V₁ = P₂V₂ at constant temperature.",
    h: "P and V are inversely related.",
    yr: "2022",
  },
];

export const WAEC_CHEMISTRY_LEARN = [
  {
    topic: "Atomic Structure",
    content: "An atom has a nucleus (protons + neutrons) surrounded by electrons. Atomic number = protons. Mass number = protons + neutrons. Isotopes have the same proton count but different neutron counts. Electron configuration fills shells: 2, 8, 8, 18...",
  },
  {
    topic: "Chemical Bonding",
    content: "Ionic bonds: transfer of electrons between metal and non-metal. Covalent bonds: sharing of electrons between non-metals. Metallic bonds: sea of delocalized electrons among metal atoms. Hydrogen bonds: weak attractions involving H bonded to N, O, or F.",
  },
  {
    topic: "Acids, Bases & Salts",
    content: "Acids donate H⁺ ions; bases accept H⁺ or donate OH⁻. Strong acids: HCl, H₂SO₄, HNO₃. Strong bases: NaOH, KOH. Neutralisation: acid + base → salt + water. pH scale: 0–14. Indicators change colour at different pH values.",
  },
  {
    topic: "Electrolysis",
    content: "Electrolysis uses electricity to drive non-spontaneous reactions. Anode (positive electrode): oxidation occurs. Cathode (negative electrode): reduction occurs. Used in electroplating, extraction of metals (e.g. aluminium from bauxite), and purification of copper.",
  },
  {
    topic: "Organic Chemistry",
    content: "Hydrocarbons contain only C and H. Alkanes (CₙH₂ₙ₊₂) — saturated, single bonds. Alkenes (CₙH₂ₙ) — unsaturated, double bond. Alkynes — triple bond. Functional groups: –OH (alcohol), –COOH (carboxylic acid), –CHO (aldehyde), –CO– (ketone), –NH₂ (amine).",
  },
];
